import { get } from 'lodash';
import { pagingWithResults, paging, sortingFilters } from '@/constants/states';
import { readStates } from '@/constants/lifecycle';
import findResult, { assignIfExists } from '@/utils/resultsHelper';

const auditResults = (code, orderBy = [{ column: 'when', direction: 'desc' }], singleSorting = true) => ({
  code,
  name: '',
  ...pagingWithResults(),
  ...readStates,
  ...sortingFilters(orderBy, singleSorting),
  filters: {
    when: '',
    who: '',
    as: '',
    what: '',
    entity: '',
  },
});

export const newAuditList = (code) => (auditResults(code));

const initialState = {
  audits: {
    all: { results: [newAuditList(null)] },
    cohort: { results: [] },
    collection: { results: [] },
    dataset: { results: [] },
    request: { results: [] },
    role: { results: [] },
    search: { results: [] },
    user: { results: [] },
    usergroup: { results: [] },
  },
};

export const auditsResult = (result) => ({ ...result });

export const auditStateToLoad = ({ audit }) => {
  const items = get(audit, 'audits', initialState.audits);
  const allItems = items.all || initialState.audits.all;
  const result = allItems.results ? allItems.results[0] : {};

  return {
    audits: {
      ...initialState.audits,
      all: {
        ...allItems,
        results: [
          auditResults(result.code, result.orderBy, result.singleSorting),
        ],
      },
    },
  };
};

export const auditStateToSave = ({ audit }) => {
  const items = get(audit, 'audits', initialState.audits);
  const allItems = items.all || initialState.audits.all;
  const result = allItems.results ? allItems.results[0] : {};

  return {
    audit: {
      audits: {
        all: {
          results: [
            auditResults(result.code, result.orderBy, result.singleSorting),
          ],
        },
      },
    },
  };
};

export const findAudit = ({ audits }, { category, code }) => findResult(audits, category, code);

export const updateAuditName = (draft, category, code, name) => {
  const item = findAudit(draft, { category, code });
  if (item) {
    assignIfExists(item, { name });
  }
};

export const findAudits = (audits, category, code) => {
  const defaultAudit = {
    results: [], name: '', ...readStates, ...paging(), isDefault: true,
  };
  const item = findResult(audits, category, code) || defaultAudit;
  return { defaultAudit, item };
};

export default initialState;
